import VueGtag from 'vue-gtag-next';

export default VueGtag;
